import totalDayMinutes from '../totalDayMinutes'

export default ({ width }) => (15 / totalDayMinutes) * width
